import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { Cloud } from "lucide-react";

const Field = ({ id, label, value, onChange, placeholder, type = "text", hint, testId }) => (
  <div>
    <Label htmlFor={id}>{label}</Label>
    <Input id={id} type={type} value={value || ""} onChange={onChange} placeholder={placeholder} autoComplete="off" className="mt-1 font-mono text-sm" data-testid={testId} />
    {hint && <p className="text-xs text-slate-500 mt-1">{hint}</p>}
  </div>
);

export const GraphEmailSettings = ({ settings, onChange }) => {
  const set = (k) => (e) => onChange({ ...settings, [k]: e.target.value });
  return (
    <div className="space-y-4 p-4 bg-sky-50 border border-sky-200 rounded-lg" data-testid="graph-email-settings">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-2">
          <Cloud className="w-5 h-5 text-sky-700 mt-0.5" />
          <div>
            <h3 className="font-semibold text-sky-900">Microsoft Graph (Microsoft 365) — app-only</h3>
            <p className="text-sm text-sky-800">Sends every email through the Graph API as the mailbox below. No SMTP, no basic auth. All invoices, quotes, receipts, reminders, appointment confirmations (with .ics), backups and test emails use it.</p>
          </div>
        </div>
        <Badge className={settings.graph_configured ? "bg-emerald-100 text-emerald-800 border-emerald-200" : "bg-amber-100 text-amber-800 border-amber-200"} data-testid="graph-status-badge">
          {settings.graph_configured ? "CONFIGURED" : "NOT CONFIGURED"}
        </Badge>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Field id="graph_tenant_id" label="Directory (tenant) ID *" value={settings.graph_tenant_id} onChange={set("graph_tenant_id")} placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" testId="graph-tenant-input" />
        <Field id="graph_client_id" label="Application (client) ID *" value={settings.graph_client_id} onChange={set("graph_client_id")} placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" testId="graph-client-input" />
        <Field id="graph_client_secret" label="Client secret *" type="password" value={settings.graph_client_secret} onChange={set("graph_client_secret")}
          placeholder={settings.graph_client_secret_configured ? "•••••••• (saved — paste to replace)" : "Secret value from Certificates & secrets"} hint="Stored server-side only; never shown again." testId="graph-secret-input" />
        <Field id="graph_mailbox" label="Send-as mailbox (UPN) *" value={settings.graph_mailbox} onChange={set("graph_mailbox")} placeholder="info@cgnetworks.cloud" hint="Licensed Exchange mailbox the app sends from." testId="graph-mailbox-input" />
      </div>
      <details className="text-sm text-sky-900" data-testid="graph-setup-steps">
        <summary className="cursor-pointer font-medium">Entra ID setup checklist</summary>
        <ol className="list-decimal ml-5 mt-2 space-y-1 text-sky-800">
          <li>Entra admin center → App registrations → New registration (single tenant, no redirect URI).</li>
          <li>API permissions → Microsoft Graph → <b>Application</b> permissions → <b>Mail.Send</b> → Grant admin consent.</li>
          <li>Certificates &amp; secrets → New client secret → copy the <i>Value</i> (shown once).</li>
          <li>Optional: limit the app to this one mailbox with Exchange Online RBAC for Applications.</li>
          <li>Save here, then use "Send Test" below. 403 = consent/mailbox restriction, 404 = wrong mailbox, 401 = wrong IDs/secret.</li>
        </ol>
      </details>
    </div>
  );
};
